

export const THEMES = [
    {
        name: 'dark'
    },
    {
        name: 'light'
    }
]